import { Modal } from '@/components/modal/Modal';
import { useModal } from '@/components/modal/useModal';
import { Card } from '@/components/sections/Card';
import { FC, PropsWithChildren, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { PurchaseOrderNavigationContext, PurchaseOrderStep } from './purchaseOrderHooks';
import { usePoValidateDeliveryAddress } from './usePoValidateDeliveryAddress';

export const PurchaseOrderNavigationProvider: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();
  const validateDelivery = usePoValidateDeliveryAddress();

  const modalProps = useModal<string>();

  const navigateAndValidate = useCallback(
    (link: string, step?: PurchaseOrderStep) => {
      let errorMessage: string = '';

      if (step) {
        if (step > PurchaseOrderStep.DELIVERY) {
          errorMessage = validateDelivery();
        }
      }

      if (errorMessage) {
        modalProps.open(errorMessage);
      } else {
        navigate(link);
      }
    },
    [navigate, open]
  );

  return (
    <PurchaseOrderNavigationContext.Provider value={navigateAndValidate}>
      <Modal className="md:max-w-xl" {...modalProps}>
        <Card className="flex w-full flex-col gap-2 p-5">
          <Modal.Controls {...modalProps}>
            <span className="text-lg font-mid">Info</span>
          </Modal.Controls>
          {modalProps.props}
        </Card>
      </Modal>
      {children}
    </PurchaseOrderNavigationContext.Provider>
  );
};
